<template>
  <v-container :fluid="true" class="page_container">
    <div class="partner__title">
      <span class="partner__title--text">
        ПАРТНЕР
      </span>
    </div>
    <div class="partner__container" v-if="getPartnersDetail !== null && !isLoading">
      <div class="partner__top_name">
        {{ getPartnersDetail.name }}
      </div>
      <div
          class="partner__back"
          @click.stop="returnParent"
      >
        <v-icon size="24" class="font-weight-bold">west</v-icon>
      </div>
      <div class="partner__logo">
        <v-img
            alt="placeholder_partner"
            max-width="80%"
            max-height="300"
            aspect-ratio="1"
            :src="getFileLink(getPartnersDetail.logo.link)"
        />
      </div>
      <div class="partner__text">
        <span v-html="addMailGetParams(getPartnersDetail.description)">
        </span>
      </div>
      <div class="partner__text mb-10">
        <p v-if="getPartnersDetail.region_data.is_excluded">
          <b>Партнер работает во всех регионах, кроме следующих: </b>
          <span v-for="(item, index) in getPartnersDetail.region_data.regions" :key="`${index}_region`">
            {{ item.region.name }}<span v-if="index !== getPartnersDetail.region_data.regions.length - 1">, </span>
          </span>
        </p>
        <p v-else-if="!getPartnersDetail.region_data.is_excluded && getPartnersDetail.region_data.regions.length > 0">
          <b>Партнер работает в следующих регионах: </b>
          <span v-for="(item, index) in getPartnersDetail.region_data.regions" :key="`${index}_region`">
            {{ item.region.name }}<span v-if="item.cities.length > 0">
              (<span v-for="(i, index) in item.cities" :key="`${index}_city`">
                {{ i.city }}<span v-if="index !== item.cities.length - 1">, </span>
              </span>)</span><span v-if="index !== getPartnersDetail.region_data.regions.length - 1">, </span>
          </span>
        </p>
        <p v-else-if="getPartnersDetail.region_data.regions === 0"><b>Партнер доступен во всех регионах</b></p>
      </div>
      <v-row no-gutters class="mb-5" justify="start" v-if="$vuetify.display.width > 1596">
        <div v-for="(item, i) in getPartnersDetail.tags" :key="i">
          <v-btn color="#376FFE" variant="flat" class="filter-btn" @click="filterPartnersToCategory(item.id)">{{item.name}}</v-btn>
        </div>
      </v-row>
    </div>
    <div v-else-if="getPartnersDetail === null && !isLoading">
      <NoData/>
    </div>
    <div class="partner__container" v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters, mapMutations } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import helper from "@/urls/helper"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "PartnersDetail",
  components: {
    NoData,
    FulfillingSquareSpinner
  },
  data () {
    return {
      isLoading: true,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getPartnersDetail: 'personal_account/partners/getPartnersDetail',
      member: 'personal_account/members/getMembers'
    }),
  },
  methods: {
    ...mapActions({
      loadPartnersDetail: 'personal_account/partners/loadPartnersDetail',
      loadMembers: 'personal_account/members/loadMembers',
    }),
    ...mapMutations({
      SET_MEMBERS: 'personal_account/members/SET_MEMBERS'
    }),
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },

    addMailGetParams (value) {
      let mailfix = ''
      if (this.member) {
        if (this.member.card) {
          mailfix = '?email=' + this.member.card.number + '@mail.mendeleevskayakarta.ru'
        }
      }
      return value.replace('?email={***}', mailfix)
    },
    returnParent () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: names.PARTNER.PAGE })
    },
    filterPartnersToCategory (value) {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: names.PARTNER.PAGE, query: { tag: value } })
    },
    loadDataMember (url = undefined) {
      this.loadMembers({
        url: url,
        finalizer: (data) => {
          if (data.member_request.is_two_profiles) {
            data.member_request.education_level = 'Бакалавриат (с двумя профилями)'
          }
          this.SET_MEMBERS(data)
        },
        catcher: () => {}
      })
    },
    loadData (url = undefined) {
      this.loadPartnersDetail({
        id: this.$route.params.id,
        finalizer: () => {
          this.isLoading = false
        },
        catcher: () => {}
      })
    },
  },
  beforeMount () {
    if (window.scrollY !== 0) {
      window.scroll({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
      if (!this.member) {
        this.loadDataMember()
      }
    }
  }
})
</script>

<style scoped lang="scss">
.partner__title {
  display: flex;
  justify-content: space-between;
}

.partner__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.partner__container {
  position: relative;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 50px;
}

.partner__content {
  display: flex;
  position: relative;
}

.partner__top_name {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  padding: 0 50px;
  max-width: 70%;
  height: 50px;
  background-color: #3254B9;
  border-radius: 5px 0;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
}

.partner__back {
  content: "";
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: #376FFE;
  border-radius: 5px;
  cursor: pointer;
}

.partner__logo {
  display: inline-flex;
  align-content: center;
  justify-content: center;
  margin-top: 50px;
}

.partner__text {
  margin-top: 50px;
  font-style: normal;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  overflow: hidden;
}

.filter-btn {
  font-size: 16px;
  line-height: 20px;
  margin: 10px 10px;
  border-radius: 5px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: white;

  @media (max-width: 600px) {
    margin: 5px 5px;
    font-size: 13px;
  }
}

@media screen and (max-width: 768px) {
  .partner__title {
    margin-top: 20px;
  }

  .partner__container {
    padding: 20px;
  }

  .partner__top_name {
    font-size: 16px;
    line-height: 19px;
    padding: 10px 20px;
    min-height: 50px;
    height: inherit;
  }

  .partner__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>
